import 'bootstrap';
import 'react-dates/initialize';



// WEBPACK FOOTER //
// ./src/boot/externalModules.ts